import { useState } from "react";
import {
  Card,
  CardContent,
  Stack,
  Box,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";

// import { useDispatch } from "react-redux";
import { AuthLayout } from "../../layouts";
import SigninTextInput from "../../components/SigninTextInput";
import { CustomButton } from "../../components";
import { capitalizeFirstLetter } from "../../utils/strings";
import i18n from "../../i18n-config";
import theme from "../../theme/theme";
import SigninHeader from "./components/SigninHeader";
import { LockICON } from "../../assets/icons";

const Signup = () => {
  // let navigate = useNavigate();
  // const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // const [isLoading, setIsLoading] = useState(false);

  // const callback = () => {
  //   setIsLoading(false);
  //   navigate("/");
  // };

  const onChangeUsername = (value: string) => {
    setUsername(value);
  };

  const onChangePassword = (value: string) => {
    setPassword(value);
  };

  const onSubmit = async (event: any) => {
    try {
      event.preventDefault();

      // const user = users.filter(
      //   (user) =>
      //     user.username?.toLowerCase() === username.toLowerCase() &&
      //     user?.password === password
      // );
      // setIsLoading(true);

      // if (user.length) {
      //   dispatch(createUser(user[0]));
      //   navigate("/sale");
      // } else {
      //   showError(
      //     capitalizeFirstLetter(i18n.t("incorrect_username_or_password")),
      //     {
      //       horizontal: "right",
      //       vertical: "bottom",
      //     }
      //   );
      // }

      // setIsLoading(false);
    } catch (error) {
      // showError(capitalizeFirstLetter(i18n.t("error_occured")), {
      //   horizontal: "right",
      //   vertical: "bottom",
      // });
      // setIsLoading(false);
      // dispatch(authIsLoaded(false));
      console.log(error);
    }
  };

  const disabled = !username?.trim() || !password?.trim();

  return (
    <AuthLayout
      onSubmit={onSubmit}
      leftComponent={
        <Card
          sx={{
            maxWidth: { xs: "100%", md: 500, lg: 500 },
            boxShadow: "none",
            maxHeight: "100vh",
          }}
        >
          <CardContent>
            <Box
              sx={{
                width: "100%",
              }}
              mt={3}
            >
              <SigninHeader
                title={i18n.t("bienvenue")}
                subTitle={i18n.t("bienvenue_desc")}
              />
              <SigninTextInput
                title={capitalizeFirstLetter(i18n.t("votre_email"))}
                value={username}
                onChange={onChangeUsername}
              />
              <SigninTextInput
                title={capitalizeFirstLetter(i18n.t("motdepasse"))}
                value={password}
                onChange={onChangePassword}
                type="password"
                endIcon={<LockICON />}
              />
              <SigninTextInput
                title={capitalizeFirstLetter(i18n.t("motdepasse_confirmer"))}
                value={password}
                onChange={onChangePassword}
                type="password"
                endIcon={<LockICON />}
              />

              <Stack direction={"row"} mt={2}>
                <CustomButton
                  title={capitalizeFirstLetter(i18n.t("enregistrer"))}
                  onClick={onSubmit}
                  disabled={disabled}
                  rootStyle={{
                    width: "100%",
                    borderRadius: 50,
                  }}
                  titleStyle={{ color: theme.colors.white }}
                />

              </Stack>
            </Box>
          </CardContent>
        </Card>
      }
    />
  );
};

export default Signup;
